import type { HttpErrorResponse } from '@angular/common/http';

import type {
  LanguageItem,
  LanguageTranslations,
  LanguageTranslationsItem,
} from '@core/languages-types';
import { createSingleEntityStore } from '@core/ngrx-legacy';

import { EntityStoreKey } from '../../types';

const { actions, selectors, reducer, namespace } = createSingleEntityStore<LanguageTranslations>()(
  EntityStoreKey.languageTranslations,
  {
    customActions: adapter => ({
      fetch: (state, payload: number) => adapter.markAsPending(state),

      createLanguageTranslations: (
        state,
        payload: {
          viewboxTranslations: LanguageTranslationsItem;
          careersSitesTranslations: LanguageTranslationsItem;
          language: { code: string };
        },
      ) => adapter.markAsPending(state),
      createLanguageTranslationsSuccess: (state, payload: LanguageItem) =>
        adapter.markAsLoaded(state),
      createLanguageTranslationsFailed: (state, payload: HttpErrorResponse) =>
        adapter.setError(state, payload),

      updateLanguageTranslations: (
        state,
        payload: {
          body: {
            viewboxTranslations: LanguageTranslationsItem;
            careersSitesTranslations: LanguageTranslationsItem;
          };
          languageId: number;
        },
      ) => adapter.markAsPending(state),
      updateLanguageTranslationsSuccess: (state, payload: LanguageItem) =>
        adapter.markAsLoaded(state),
      updateLanguageTranslationsFailed: (state, payload: HttpErrorResponse) =>
        adapter.setError(state, payload),

      deleteLanguage: (state, payload: number) => adapter.markAsPending(state),
      deleteLanguageSuccess: (state, payload: LanguageItem) => adapter.markAsLoaded(state),
      deleteLanguageFailed: (state, payload: HttpErrorResponse) => adapter.setError(state, payload),

      toggleLanguageEnable: (
        state,
        payload: {
          id: number;
          enabled: boolean;
        },
      ) => adapter.markAsPending(state),
      toggleLanguageEnableSuccess: (state, payload: LanguageItem) => adapter.markAsLoaded(state),
      toggleLanguageEnableFailed: (state, payload: HttpErrorResponse) =>
        adapter.setError(state, payload),
    }),
  },
);

export {
  actions as LanguageTranslationsActions,
  reducer as LanguageTranslationsReducer,
  selectors as LanguageTranslationsSelectors,
  namespace as LanguageTranslationsNamespace,
};
